/**
 * Which build of Grow this actually is.
 *
 * An installed app serves itself from a cached copy, so "I pushed it" and
 * "you have it" are different facts about different machines. Without a
 * version on screen the only way to settle which one you are looking at is
 * for somebody to assert it, which is how an afternoon gets spent arguing
 * about a deploy that had already happened.
 *
 * The string is `grow@<commit>`, stamped in at build time and otherwise sent
 * only to error reports. Selectable, because the point is to be able to read
 * it out.
 *
 * Also carries the quiet Privacy link (PRIVACY_URL, the policy on the website)
 * beneath the version.
 *
 * Used by: UserProfile, at the foot of the list. __GROW_RELEASE__ is declared
 * in src/vite-env.d.ts and replaced at build time by vite.config.ts `define`.
 *
 * @module AppVersion
 */

import React from 'react';
import { useTranslation } from '@/shared/hooks/useTranslation';
import { PRIVACY_URL } from '@/config/tunables/shared';

/** The build's version line, and the Privacy link, at the foot of the profile. */
export const AppVersion: React.FC = () => {
  const { reactTranslate: t } = useTranslation();

  return (
    <p className="pb-2 text-center text-xs text-muted-foreground">
      {t('profile.version')}{' '}
      <span className="select-all font-mono">{__GROW_RELEASE__}</span>
      {' · '}
      <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" className="underline underline-offset-2">
        {t('profile.privacy')}
      </a>
    </p>
  );
};
